import { studentBookingClient } from '../client';

import { DevelopmentDetails, GetDevelopmentDetailsSuccessResponse } from './types';
import { DevelopmentServiceEndpoints } from './constants';

export const getDevelopmentDetails = async (
    developmentSlug: string,
    academicYear: string
): Promise<DevelopmentDetails> => {
    const { data: response } = await studentBookingClient.get<GetDevelopmentDetailsSuccessResponse>(
        `${DevelopmentServiceEndpoints.GetDevelopmentDetails.replace(
            '{developmentSlug}',
            developmentSlug
        )}?academicYear=${encodeURIComponent(academicYear)}`
    );

    return response.data;
};
